import React, { memo } from "react";
import { Button, makeStyles } from "@material-ui/core";

import { ListAddItemIcon } from "../../../icons";
import palette from "../../../styles/palette";

const useStyles = makeStyles(() => ({
  wrapper: {
    boxShadow: "-6px 0px 0px -5px white",
    height: "48px",
    color: palette.typography.white.solid,
    opacity: 0.54,
  },
}));

const ListAddItemButton = ({ onClick }) => {
  const styles = useStyles();

  return (
    <Button
      onClick={onClick}
      className={styles.wrapper}
      data-testid="list-add-item"
    >
      <ListAddItemIcon />
    </Button>
  );
};

export default memo(ListAddItemButton);
